import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useEffect, useState} from 'react';
import {useFullScreenView} from '../../../client-services/LaunchTeaser/useFullScreenView';

let isHeaderDisabledGlobal = false;
let isFooterDisabledGlobal = false;

export const useHelpCenterChatbotActive = () => {
  const {isActive} = useIsFeatureActive('enable_cs_chatbot');
  const {isHeaderDisabled, isFooterDisabled} = useFullScreenView();
  const [isHeaderDisabledState, setIsHeaderDisabledState] = useState(
    isHeaderDisabledGlobal,
  );
  const [isFooterDisabledState, setIsFooterDisabledState] = useState(
    isFooterDisabledGlobal,
  );

  useEffect(() => {
    if (!isHeaderDisabledGlobal && isHeaderDisabled) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setIsHeaderDisabledState(isHeaderDisabled);
      isHeaderDisabledGlobal = isHeaderDisabled;
    }
  }, [isHeaderDisabled, setIsHeaderDisabledState]);

  useEffect(() => {
    if (!isFooterDisabledGlobal && isFooterDisabled) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setIsFooterDisabledState(isFooterDisabled);
      isFooterDisabledGlobal = isFooterDisabled;
    }
  }, [isFooterDisabled, setIsFooterDisabledState]);

  return isActive && (!isHeaderDisabledState || !isFooterDisabledState);
};
